module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABuCAMAAAB2tD/PAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA8UlEQVR42uzYwQ4CIQwE0On//7QxHoxS6FCsYdnh4mGZl90GoQFWOyBf/tV8NCM7ybiklyVnccFNfBA+yZMf0PMTK0W+fPny5df7Vudb0jf2fFR/JT/tY3lU+xj5uLhfXR+t//P94vNF/YN8+fLl7+yjzLfi+7Hq+73y+083+lO/DWdfYqU/IZaA+jf58v/lZ4+VvXxqW6FDp/g+GBU3Dp3i+xpd/7v4XinHN0nPH77+r9mfRuh7ocZ/P5vw+6He+pzbvOIQhl055xvlJ9YPEdL/62Y+MucX2PNr0o9D+N7binz/VpXxxyH1t/JXxkOAAQAncCHYruULkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/Scan_QR_Code.png
// module id = DKU7
// module chunks = 1